import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface LogoLinksSearchStyles {
    container: InjectableCss;
    logoWrapper: InjectableCss;
    searchMenuWrapper: InjectableCss;
    linkListHidden: HiddenProps;
    bannerWrapper: InjectableCss;
}

export const logoLinksSearchStyles: LogoLinksSearchStyles = {
    container: {
        css: css`
            display: flex;
            justify-content: space-between;
            max-width: 1400px;
            margin: 0 auto !important;
            min-height: 100px;
        `,
    },
    logoWrapper: {
        css: css`
            margin: auto;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            flex-grow: 1;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
            img {
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                height: 100px;
                                width: auto;
                                margin: 0;
                            `,
                            null,
                            null,
                        ],
                        "max",
                    );
                }}
            }
        `,
    },
    searchMenuWrapper: {
        css: css`
            text-align: right;
            margin: auto;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            flex-shrink: 2;
                        `,
                        css`
                            flex-grow: 8;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    linkListHidden: {
        below: "lg",
    },
    bannerWrapper: {
        css: css`
            text-align: center;
            margin: auto;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            flex-shrink: 2;
                        `,
                        css`
                            flex-grow: 8;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
};

const LogoLinksSearch: React.FC<PageProps> = ({ id }) => (
    <Hidden below="lg">
        <StyledWrapper {...logoLinksSearchStyles.container}>
            <StyledWrapper {...logoLinksSearchStyles.logoWrapper}>
                <Zone contentId={id} zoneName="Logo" />
            </StyledWrapper>
            <StyledWrapper {...logoLinksSearchStyles.bannerWrapper}>
                <Zone contentId={id} zoneName="Banner" />
            </StyledWrapper>
            <StyledWrapper {...logoLinksSearchStyles.searchMenuWrapper}>
                <Zone contentId={id} zoneName="Search" />
            </StyledWrapper>
        </StyledWrapper>
    </Hidden>
);

const logoLinksSearch: WidgetModule = {
    component: LogoLinksSearch,
    definition: {
        group: "Common",
        icon: "magnifying-glass",
    },
};

export default logoLinksSearch;
